import * as React from 'react'
import type { ReactElement } from 'react'
import { useData } from './hooks'
import { CallTrackingContext } from './context'

type Props = {
  children: ReactElement
}

export function CallTrackingContextProvider(props: Props) {
  const { children } = props
  const { value } = useData()

  return (
    <CallTrackingContext.Provider value={value}>
      {children}
    </CallTrackingContext.Provider>
  )
}
